import styled from "styled-components"

const UI_Item = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  border: 1px solid transparent;
  color: #475569;
  font-size: 18px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &.element-header-item {
    width: 44px;
  }

  &:hover {
    background-color: #f1f5f9;
    color: #0f172a;
    border-color: #cbd5e1;
    transform: translateY(-1px);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
    
  &.active {
    background-color: rgba(59, 130, 246, 0.12);
    color: #2563eb;
    border-color: #93c5fd;
    box-shadow: 0 1px 3px rgba(59, 130, 246, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`

export const HeaderCenterStyles = {
  UI_Item
}